import { authFetch } from '@/lib/http';

/**
 * Delete a recording, which destroys its audio in S3 (the `.ogg` and its
 * `.m4a` sibling) along with the row.
 *
 * Rejects on a non-2xx response rather than resolving quietly: the server
 * refuses the delete when the S3 purge fails, precisely so the audio stays
 * reachable for a retry, and a caller that swallowed that would tell the user
 * their recording was deleted when it was not.
 */
export async function deleteRecording(recordingId: string): Promise<void> {
  const res = await authFetch(`/recordings/${recordingId}`, { method: 'DELETE' });
  if (!res.ok) {
    throw new Error(`Failed to delete recording ${recordingId}: ${res.status}`);
  }
}
